import { Button, Flex, Icon } from '@chakra-ui/react';
import { FaArrowRight } from 'react-icons/fa6';

interface ContractModalFooterProps {
  onCancel: () => void;
  onNext: () => void;
  cancelLabel?: string;
  nextLabel?: string;
  isNextLoading?: boolean;
  isNextDisabled?: boolean;
}

const ContractModalFooter: React.FC<ContractModalFooterProps> = ({
  onCancel,
  onNext,
  cancelLabel = 'Cancelar',
  nextLabel = 'Próximo',
  isNextLoading = false,
  isNextDisabled = false,
}) => (
  <Flex my={8} gap={6} px={8} flexShrink={0}>
    <Button flex={1} variant="regular" size="lg" onClick={onCancel}>
      {cancelLabel}
    </Button>
    <Button
      flex={1}
      variant="emphasisPrimary"
      iconSpacing="0"
      size="lg"
      rightIcon={<Icon as={FaArrowRight} boxSize="1rem" ml={0.5} />}
      onClick={onNext}
      isLoading={isNextLoading}
      isDisabled={isNextDisabled}
    >
      {nextLabel}
    </Button>
  </Flex>
);

export default ContractModalFooter;
